import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg24TemplateG = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      d: "M19.358 2a2.5 2.5 0 0 1 2.5 2.5v14.858a2.5 2.5 0 0 1-2.5 2.5H4.5a2.5 2.5 0 0 1-2.5-2.5V4.5A2.5 2.5 0 0 1 4.5 2zm0 1.4H4.5c-.607 0-1.1.494-1.1 1.1v14.858a1.1 1.1 0 0 0 1.1 1.1h14.858c.606 0 1.1-.493 1.1-1.1V4.5c0-.606-.494-1.1-1.1-1.1m-1.5 12.913a.7.7 0 0 1 .094 1.394l-.095.006H5.971a.7.7 0 0 1-.095-1.393l.095-.007h11.886zM11.27 6.476a.7.7 0 0 1 .694.605l.006.095V8.26a.7.7 0 0 1-1.393.095l-.007-.095v-.384H9.371v3.483l.679.001a.7.7 0 0 1 .095 1.394l-.095.006H7.342a.7.7 0 0 1-.095-1.394l.095-.006h.63V7.874l-1.301.001v.384a.7.7 0 0 1-.605.694l-.095.006a.7.7 0 0 1-.693-.605l-.006-.095V7.176a.7.7 0 0 1 .605-.693l.095-.007zm6.587 4.884a.7.7 0 0 1 .095 1.394l-.095.006h-3.666a.7.7 0 0 1-.095-1.394l.095-.006zm0-4.884a.7.7 0 0 1 .095 1.394l-.095.006h-3.666a.7.7 0 0 1-.095-1.394l.095-.006z"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg24TemplateG$1 = Svg24TemplateG;

export { Svg24TemplateG$1 as default };
